import { DELETE, DOWNLOAD_FILE, GET, POST, PUT } from "@/utils/http";

const APPROVER_BASE_URI = "/license-registration";

export const LicenseRegistrationService = {
  create(
    request: CreateLicenseRegistrationRequest,
  ): Promise<SuccessResponse | null | undefined> {
    return POST<SuccessResponse>(
      `${APPROVER_BASE_URI}/create`,
      request,
      undefined,
      true,
    );
  },
  update(
    licenseRegistrationId: string,
    request: CreateLicenseRegistrationRequest,
  ): Promise<SuccessResponse | null | undefined> {
    return PUT<SuccessResponse>(`${APPROVER_BASE_URI}/edit`, request, {
      params: { licenseRegistrationId: licenseRegistrationId },
    });
  },
  getDetail(
    licenseRegistrationId: string,
  ): Promise<LicenseRegistrationDetail | null | undefined> {
    return GET<LicenseRegistrationDetail>(
      `${APPROVER_BASE_URI}/detail/${licenseRegistrationId}`,
      undefined,
      true,
    );
  },
  delete(
    licenseRegistrationId: string,
  ): Promise<SuccessResponse | null | undefined> {
    return DELETE<SuccessResponse>(
      `${APPROVER_BASE_URI}/delete/${licenseRegistrationId}`,
    );
  },
  search(
    request: SearchLicenseRegistrationListRequest,
  ): Promise<SearchLicenseRegistrationResponse | null | undefined> {
    return POST<SearchLicenseRegistrationResponse>(
      `${APPROVER_BASE_URI}/search`,
      request,
    );
  },
  sendLicenseFile(
    request: SendLicenseEmailRequest,
  ): Promise<SuccessResponse | null | undefined> {
    return POST<SuccessResponse>(
      `${APPROVER_BASE_URI}/send-license-file`,
      request,
      undefined,
      true,
    );
  },
  sendMailExpiringSoon(
    licenseRegistrationId: string,
  ): Promise<SuccessResponse | null | undefined> {
    return GET<SuccessResponse>(
      `${APPROVER_BASE_URI}/warning-expiring-soon/${licenseRegistrationId}`,
      undefined,
      true,
    );
  },
  download(licenseRegistrationId: string) {
    const url = `${APPROVER_BASE_URI}/download/${licenseRegistrationId}`;
    return DOWNLOAD_FILE(url, "license.lic");
  },
};
